module.exports = __webpack_public_path__ + "media/images/product_owners/cbp-1c2a8ef4a6910912727b6d528150e343.png";